import { apiClient } from '../services/api-client';

/**
 * Fetches a care-hooks endpoint.
 *
 * The response is unvalidated JSON, so `TData` is an unchecked claim confined to this
 * boundary rather than validation — see the note in `LyticsFetcher`. It defaults to
 * `number` because the single consumer (`alertsCountOptions` in `home/alerts/index.tsx`,
 * on `/hooks/alerts-count/{practitionerId}`) compares the result numerically.
 *
 * The return folds in `undefined` via `Fetched<T>`: the empty-`endPoint` guard below
 * resolves without calling the API, and SWR's `Fetcher<Data>` has no room for that
 * `undefined` unless it is part of `Data`. See `Fetched` in `types/food.ts`.
 */
const HooksFetcher = async <TData = number>(
  endPoint: string,
  token: string,
): Promise<TData | undefined> => {
  if (!endPoint || !endPoint.length) {
    return;
  }

  const result = await apiClient.get<TData>(import.meta.env.VITE_CARE_HOOKS_API_NAME, endPoint, {
    headers: {
      Authorization: 'Bearer ' + token,
      'Content-Type': 'application/json',
    },
  });
  return result;
};

export default HooksFetcher;
